/**
 * next-steps-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AlgorithmStep, ComputationStep, IntakeStep, ReportStep }
  from "../../../algorithms/structure";
import { validateAs, validateFor } from "../../validation/decorators";
import { interpolateInPlace } from "../../validation/interpolation";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * After a server successfully processes a {@link StartAlgorithmRequest}, it may
 * asynchronously respond with {@code NextStepsMessage}s that encodes
 * {@link IntakeStep}s and {@link ReportStep}s to present. This may happen as a
 * consequence of receiving new answers (e.g., from a {@link
 * SubmitAnswersUpstreamMessage}) or completing computation steps. Note that a
 * {@link NextStepsResponse} is always given a unique server-allocated message
 * identifier.
 */
@validateFor(MessageTag.RSP_NEXT_STEPS)
export class NextStepsResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_NEXT_STEPS;

  @validateAs({array: "object"}, true, [],
    (json : any) => json.intakeSteps.forEach(
      (i : IntakeStep) => interpolateInPlace(i))) // TODO: better validation
  public intakeSteps : IntakeStep[];

  @validateAs({array: "object"}, true, [],
    (json : any) => {
      json.reportSteps.forEach(
        (r : ReportStep) => interpolateInPlace(r));
      if (json.reportSteps.length)
      {
        console.log("reportSteps", json.reportSteps);
      }
    }) // TODO: better validation
  public reportSteps : ReportStep[];

  @validateAs({array: "object"}, true, []) // TODO: better validation
  public computationSteps : ComputationStep[];

  public static InstantiateSteps (nsr : NextStepsResponse) : AlgorithmStep[]
  {
    return [].concat(
      nsr.intakeSteps.map((step : IntakeStep) => new IntakeStep(step)),
      nsr.reportSteps.map((step : ReportStep) => new ReportStep(step)),
      nsr.computationSteps.map(
        (step : ComputationStep) => new ComputationStep(step))
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/next-steps-response.ts